import React, { useState } from 'react';
import { useSelector } from 'react-redux';

// components
import UnsubscribeView from './UnsubscribeView';

// actions
import { updateSubscription } from 'app/shared/flux/actions/MarketingActions';
import { useAppDispatch } from 'app/shared/flux/hooks';

// misc/utils
import { toSubscriptionResult } from 'app/shared/utils/unsubscribeUtils';
import { queryStringToQueryObject } from 'app/shared/utils/urlUtils';

// types
import type { State } from 'app/shared/types/State';
import type { MarketUpdateStatusErrorType, MarketUpdateStatusType } from 'app/shared/types/ApiResponseTypes';
import { logError } from '@zg-rentals/log-error';

const UnsubscribePage = () => {
  const queryString = useSelector((state: State) => state.router.location.search);
  const pathname = useSelector((state: State) => state.router.location.pathname);
  const unsubscribeResult = useSelector((state: State) => state.marketing.unsubscribeResult);
  const dispatch = useAppDispatch();
  const queryObj = queryStringToQueryObject(queryString);
  const { email, marketUpdateId } = queryObj;
  const [isSubscribed, setIsSubscribed] = useState(unsubscribeResult.success ? unsubscribeResult.isSubscribed : null);
  const [address, setAddress] = useState(unsubscribeResult.success ? unsubscribeResult.address : null);
  const [isErrored, setIsErrored] = useState(!unsubscribeResult.success);
  const handleUndoClick = () => {
    dispatch(updateSubscription({ email, enabled: !isSubscribed, marketUpdateId }))
      // @ts-ignore
      .then((res: MarketUpdateStatusType) => {
        const result = toSubscriptionResult(res);
        setIsSubscribed(result.isSubscribed);
        setAddress(result.address);
        return;
      })
      .catch((err: MarketUpdateStatusErrorType) => {
        logError({
          error: err,
          errorType: 'Subscription',
          context: {
            details: 'Unsubscribe Page: Error updating subscription',
            root: 'pages/UnsubscribePage#handleUndoClick',
            pathAttempted: pathname,
            queryAttempted: queryString,
          },
        });
        setIsErrored(true);
      });
  };
  return (
    <UnsubscribeView
      email={email}
      address={address}
      isSubscribed={isSubscribed}
      isErrored={isErrored}
      onUndo={handleUndoClick}
    />
  );
};

export default UnsubscribePage;
